// @flow
import React from 'react';
import { Button } from '@finect/tabular-core/Button';
import { ArrowLeft } from '@finect/tabular-icons/arrowLeft';
import { ChevronDown } from '@finect/tabular-icons/chevronDown';
import {
  InsideNavigationContainer,
  InsideNavigationInner,
  NavBack,
  NavOption,
  NavOptionLink,
  NavSubOptionLink,
  NavSelectBlock,
  NavSelect
} from './partials';

type Props = {
  links: Array<{
    title: string,
    path: string,
    sublinks?: Array<{
      title: string,
      path: string
    }>
  }>,
  currentPath: string,
  buttonText?: string,
  redirectTo: Function,
  toggleModal: Function
};

type State = {
  reveal: boolean
};

export class InsideNavigation extends React.Component<Props, State> {
  filterSelect: any;

  state = {
    reveal: true
  };

  handleOmniNavChange = (event: SyntheticUIEvent<>) => {
    this.setState({
      reveal: event.detail === 'opened'
    });
  };

  componentDidMount() {
    window.addEventListener('OmniNavStateChanged', this.handleOmniNavChange);
  }

  componentWillUnmount() {
    window.removeEventListener('OmniNavStateChanged', this.handleOmniNavChange);
  }

  handleChange = () => {
    this.props.redirectTo(this.filterSelect.value);
  };

  /* eslint-disable */
  backClickNav = () => {};

  clickNav = (event: SyntheticEvent<HTMLElement>) => {};
  /* eslint-enable */

  render() {
    const { reveal } = this.state;
    const { links, currentPath, buttonText, toggleModal } = this.props;
    const current = links.find(item => currentPath.includes(item.path));
    return (
      <InsideNavigationContainer reveal={reveal}>
        <InsideNavigationInner>
          <nav>
            <NavBack onClick={this.backClickNav} to="/asesores">
              <ArrowLeft size="22" strokeWidth="1.8" />
              Asesores
            </NavBack>
            {links.map((link, index) => {
              const isSelected = currentPath.includes(link.path);
              if (!link.sublinks) {
                return (
                  <NavOptionLink onClick={this.clickNav} key={index} selected={isSelected} to={link.path}>
                    {link.title}
                  </NavOptionLink>
                );
              }
              let currentSection;
              if (isSelected) {
                currentSection = link.sublinks.find(item => item.path === currentPath);
              }
              return (
                <NavOption key={index} selected={isSelected}>
                  {link.title}
                  {currentSection ? <span>: {currentSection.title}</span> : null}
                  <ChevronDown size="16" strokeWidth="2.4" />
                  <ul>
                    {link.sublinks &&
                      link.sublinks.map((sublink, subindex) => (
                        <li key={subindex}>
                          <NavSubOptionLink
                            onClick={this.clickNav}
                            selected={sublink.path === currentPath}
                            to={sublink.path}
                          >
                            {sublink.title}
                          </NavSubOptionLink>
                        </li>
                      ))}
                  </ul>
                </NavOption>
              );
            })}
            <NavSelectBlock>
              <NavSelect
                onChange={this.handleChange}
                ref={article => (this.filterSelect = article)}
                value={current && current.path}
              >
                {links.map((link, index) => (
                  <option key={index} value={link.path}>
                    {link.title}
                  </option>
                ))}
              </NavSelect>
              <ChevronDown size="16" strokeWidth="2.4" />
            </NavSelectBlock>
          </nav>
          <Button width="auto" variant="small" onClick={() => toggleModal()} auto small secondary>
            {buttonText || 'Busca un asesor'}
          </Button>
        </InsideNavigationInner>
      </InsideNavigationContainer>
    );
  }
}
